import React, { useState } from 'react';
import { Box, Button, Grid, Typography, Dialog, DialogContent, TextField } from '@mui/material';
import buttonStyle from '../../../styles/buttonStyle';
import AddIcon from '@mui/icons-material/Add';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
 
const initialCustomerData = {
  Labour_Code: '',
  Model: '',
  Category: '',
  Description: '',
  Hours: '',
  Rate: '',
  Tax_Code: '',
   
 };

function CustomColumnMenu(props) {
  return (
    <GridColumnMenu
      {...props}
      slots={{
       columnMenuColumnsItem: null,
      columnMenuSortItem: null,
      }}
    />
    );
}

function SpareParts() {
  const [isAddDialogOpen, setAddDialogOpen] = useState(false);
  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [newCustomerData, setNewCustomerData] = useState(initialCustomerData);
  const [editCustomerData, setEditCustomerData] = useState(initialCustomerData);
  const [selectedRow, setSelectedRow] = useState(null);  
  const [rows, setRows] = useState([
     { id: 1, Labour_Code: 'AE0001', Model: 'Audi', Category: 'Engine', Description: 'Engine Oil Change', Hours: '2.5', Rate: '125' ,Tax_Code: '20',  },
    { id: 2, Labour_Code: 'CS0001', Model: 'Audi', Category: 'Gear Box', Description: 'Gear Box Cable Change', Hours: '0.75', Rate: '100',Tax_Code: '20',  },
    { id: 3, Labour_Code: 'Lb0002', Model: 'Audi', Category: 'Break', Description: 'Check all Break Pad', Hours: '1.5', Rate: '150' ,Tax_Code: '20',  },
    { id: 4, Labour_Code: 'GS0001', Model: 'Honda', Category: 'Body', Description: 'Check door lock', Hours: '0.5', Rate: '100',Tax_Code: '20',   },
    { id: 5, Labour_Code: 'BB0001', Model: 'Audi', Category: 'Electrical', Description: 'Replace Parking bulb', Hours: '0.5', Rate: '100' ,Tax_Code: '20',  },
    { id: 6, Labour_Code: 'FT001', Model: 'Honda', Category: 'Electrical', Description: 'Check head light bulb', Hours: '0.5', Rate: '100',Tax_Code: '20',  },
    { id: 7, Labour_Code: 'DF001', Model: 'Honda', Category: 'AC System', Description: 'Check AC Cooling', Hours: '0.5', Rate: '200' ,Tax_Code: '20',  },
    { id: 8, Labour_Code: 'BK001', Model: 'Honda', Category: 'Electrical', Description: 'Check Wiper', Hours: '0.75', Rate: '200',Tax_Code: '20',  },
  ]);

 
   const handleAddDialogOpen = () => {
    setAddDialogOpen(true);
  };

  const handleAddDialogClose = () => {
    setAddDialogOpen(false);
  };

  const handleEditDialogOpen = (row) => {
    setSelectedRow(row); // Set the selected row here
    setEditCustomerData(row);
    setEditDialogOpen(true);
  };
  

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
  };

  const handleSaveCustomer = () => {
    setRows([...rows, { id: rows.length + 1, ...newCustomerData }]);
    setNewCustomerData(initialCustomerData);
    setAddDialogOpen(false);
  };

  const handleSaveEdit = () => {
    if (selectedRow !== null) {
      const updatedRows = rows.map((row) =>
        row.id === selectedRow.id ? editCustomerData : row
      );
      setRows(updatedRows);
    }
    setEditDialogOpen(false);
  };


  const handleDelete = (customerId) => {
    const updatedRows = rows.filter((row) => row.id !== customerId);
    setRows(updatedRows);
  };
  


const columns = [
  
  {
    field: 'id',  
    headerName: 'ID',
    sortable: false,
    flex: 1,
    minWidth: 100,
    hide: true, 
  },
  { field: 'Labour_Code', headerName: 'LabourCode', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Model', headerName: 'Model', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Category', headerName: 'Category', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Description', headerName: 'Description', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Hours', headerName: 'Hours', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Rate', headerName: 'Rate', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Tax_Code', headerName: 'TaxCode', editable: false, sortable: false, flex: 1, minWidth: 100 },
   
  {
    field: 'action',
    headerName: 'Actions',
    sortable: false,
    flex: 1,
    minWidth: 180,
    renderCell: (params) => (
      <div>
        <Button
           size="small"
          startIcon={<ModeEditOutlineOutlinedIcon sx={{ color: '#0d47a1'}}/>}
          onClick={() => handleEditDialogOpen(params.row)}
        >
         </Button>
        <Button
          size="small"
          startIcon={<DeleteOutlineOutlinedIcon sx={{ color: '#b71c1c'}}/>}
          onClick={() => handleDelete(params.row.id)}
        >
         </Button>
      </div>
    ),
  },
];


return (
  <Box mt={2}>
    <Grid container spacing={1}>
    <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>LABOUR DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end'>
          <Button sx={buttonStyle.root}  onClick={handleAddDialogOpen}><AddIcon />Add Labour</Button>
            </Grid>
            </Grid>
            </Grid>
      <Grid item xs={12} mt={1}>
        <Box sx={dataGridStyle.root}>
        <DataGrid
  columnHeaderHeight={42}
  rowHeight={40}
  rows={rows}
  columns={columns}
  getRowId={(row) => row.id}
  initialState={{
    pagination: {
      pageSize: 10,
    },
  }}
  slots={{ columnMenu: CustomColumnMenu }}
  disableRowSelectionOnClick
/>
         </Box>
      </Grid>
    </Grid>


    <Dialog open={isAddDialogOpen} onClose={handleAddDialogClose}>
        <DialogContent>
        <Grid container justifyContent="center" alignItems="center" direction="column">
      <Typography variant="h6" align="center">
        <b>Add Labour</b>
      </Typography>
    </Grid>
        <Grid container spacing={2} mt="25px">
       <Grid item xs={6}>
          <TextField
            label="LabourCode"
            fullWidth
            value={newCustomerData.Labour_Code}
            onChange={(e) => setNewCustomerData({ ...newCustomerData, Labour_Code: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
            label="Model"
            fullWidth
            value={newCustomerData.Model}
            onChange={(e) => setNewCustomerData({ ...newCustomerData, Model: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
            label="Category"
            fullWidth
            value={newCustomerData.Category}
            onChange={(e) => setNewCustomerData({ ...newCustomerData, Category: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
            label="Description"
            fullWidth
            value={newCustomerData.Description}
            onChange={(e) => setNewCustomerData({ ...newCustomerData, Description: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
            label="Hours"
            fullWidth
            value={newCustomerData.Hours}
            onChange={(e) => setNewCustomerData({ ...newCustomerData, Hours: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
            label="Rate"
            fullWidth
            value={newCustomerData.Rate}
            onChange={(e) => setNewCustomerData({ ...newCustomerData, Rate: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
            label="TaxCode"
            fullWidth
            value={newCustomerData.Tax_Code}
            onChange={(e) => setNewCustomerData({ ...newCustomerData, Tax_Code: e.target.value })}
          />
                     </Grid>
                     </Grid>

        <Grid container justifyContent="flex-end" alignItems="flex-end">
          <Button 
          sx={{ backgroundColor: 'transparent', border: '1px solid #4CAF50', color: '#4CAF50' , marginTop: '10px',marginRight: '10px'}}
          onClick={handleSaveCustomer}>ADD
          </Button>

          <Button
          sx={{ backgroundColor: 'transparent',border: '1px solid #f44336', color: '#f44336', marginTop: '10px',  }}
           onClick={handleAddDialogClose}>CANCEL
          </Button>
    </Grid>

        </DialogContent>
      </Dialog>


      <Dialog open={isEditDialogOpen} onClose={handleEditDialogClose}>
        <DialogContent>
        <Grid container justifyContent="center" alignItems="center" direction="column">
      <Typography variant="h6" align="center">
       <b>Edit Labour</b>
      </Typography>
    </Grid>
        <Grid container spacing={2} mt="25px">
      <Grid item xs={6}>
           <TextField
            label="LabourCode"
            fullWidth
            value={editCustomerData.Labour_Code}
            onChange={(e) => setEditCustomerData({ ...editCustomerData, Labour_Code: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
            label="Model"
            fullWidth
            value={editCustomerData.Model}
            onChange={(e) => setEditCustomerData({ ...editCustomerData, Model: e.target.value })}
          />
          </Grid>
           <Grid item xs={6}> 
          <TextField
          label="Category"
          fullWidth
          value={editCustomerData.Category}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Category: e.target.value })}
        />
        </Grid>
           <Grid item xs={6}> 
        <TextField
          label="Description"
          fullWidth
          value={editCustomerData.Description}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Description: e.target.value })}
        />
        </Grid>
           <Grid item xs={6}> 
        <TextField
          label="Hours"
          fullWidth
          value={editCustomerData.Hours}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Hours: e.target.value })}
        />
        </Grid>
           <Grid item xs={6}> 
        <TextField
          label="Rate"
          fullWidth
          value={editCustomerData.Rate}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Rate: e.target.value })}
        />
        </Grid>
           <Grid item xs={6}> 
        <TextField
          label="TaxCode"
          fullWidth
          value={editCustomerData.Tax_Code}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Tax_Code: e.target.value })}
        />
        </Grid>
        </Grid>

        <Grid container justifyContent="flex-end" alignItems="flex-end">
            <Button          
             sx={{ backgroundColor: 'transparent', border: '1px solid #4CAF50', color: '#4CAF50' , marginTop: '10px',marginRight: '10px'}}
             onClick={handleSaveEdit}>UPDATE
             </Button>
          <Button
          sx={{ backgroundColor: 'transparent',border: '1px solid #f44336', color: '#f44336', marginTop: '10px',  }}
          onClick={handleEditDialogClose}>CANCEL
          </Button>
          </Grid>

        </DialogContent>
      </Dialog>

</Box>
)
}

export default SpareParts